export const TwilioClientEvent = {
    initialized: 'initialized',
    tokenAboutToExpire: 'tokenAboutToExpire',
    tokenExpired: 'tokenExpired',
    conversationJoined: 'conversationJoined',
    conversationUpdated: 'conversationUpdated',
};

export const ConversationEvent = {
    messageAdded: 'messageAdded',
};

export const ConversationUpdatedReason = {
    lastMessage: "lastMessage",
    lastReadMessageIndex: "lastReadMessageIndex",
};

export const MessagePageEvent = {
    lastMessage: 'message_page.last_message',
    lastReadMessageIndex: 'message_page.last_read_index',
    messageAdded: 'message_page.message_added',
    conversationJoined: 'message_page.conversation_joined',
};
